import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${({ theme }) => theme.media.tablet} {
    justify-content: space-around;
    flex-direction: row;
  }
`;

export const ImagesWrapper = styled.div`
  margin: 30px 0 30px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  overflow: hidden;

  img {
    height: auto;
    width: 100%;
    @media ${({ theme }) => theme.media.tablet} {
      width: 43%;
    }
    @media ${({ theme }) => theme.media.laptop} {
      width: 33%;
    }
    margin: 2px;
    opacity: 0.8;
    transition: all 0.2s ease-in-out;

    &:hover {
      transform: scale(1.2);
      opacity: 1;
      z-index: 999;
    }
  }
`;
